import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class UpdateProjectMutation extends Mutation {
  document = gql`
    mutation updateProject(
      $projectNumber: String!
      $isGlobal: Boolean
      $projectDescription: String
      $userId: ID
      $id: ID
    ) {
      updateProject(
        where: { id: $id }
        data: {
          isGlobal: $isGlobal
          projectNumber: $projectNumber
          projectDescription: $projectDescription
          user: { connect: { id: $userId } }
        }
      ) {
        id
        projectDescription
        projectNumber
        isGlobal
        user {
          id
          username
          firstName
          lastName
        }
      }
    }
  `;
}
